import { useAppDispatch } from '@/hooks';
import { clearAuth } from '@/store/slices/authSlice';
import React, { useEffect } from 'react';

export const Login = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(clearAuth());
    window.location.href = '/api/v3/auth/login';
    return;
  }, []);
  return <></>;
};
